/* src/modules/discounts/cards/ViewOwnerCard/styles.js */

export default theme => ({
  paper: {
    height: theme.spacing.unit * 90,
    overflow: 'auto',
  },
  emailPhoneText: {
    marginLeft: theme.spacing.unit * 3,
    marginTop: -theme.spacing.unit * 3,
  },
  card: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: theme.spacing.unit * 70,
    transform: 'translate(-50%, -50%)',
  },
  space: {
    height: theme.spacing.unit * 2,
  },
  createOwnerContent: {
    position: 'relative',
  },
  buttonContainer: {
    padding: theme.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  saveButton: {
    marginLeft: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/discounts/cards/ViewOwnerCard/styles.js